import React from 'react';
import PropTypes from 'prop-types';

import { useStaticQuery, graphql, Link } from 'gatsby'
import {array_union, sort_node_title} from 'src/uglib_utils/utils'

/**
 * ArchivalCollection - Returns a table of archival resources, optionally filtered down to a category and a sub-category.
 * 
 * When both a category and a sub category are provided, the result is the union of collections in the category and the collections in the sub-category. 
 * 
 * Eg: 
 * <ArchivalCollection category="Agriculture" other_category="Agriculture" />
 * 
 * This component will create a table containing collections where the category is "Agriculture" OR the other_category is "Agriculture".
 */

function ArchivalCollection ({category, other_category}) {

    const data = useStaticQuery(graphql`
        query ArchivesCollectionIntroQuery {
            collections: allNodeArchivesCollectionIntroPage(sort: {title: ASC}) {
            edges {
                node {
                title
                path {
                    alias
                }
                field_aci_dates
                field_aci_archives_category
                field_aci_other_category
                field_aci_short_description
                field_published
                }
            }
            }
        }
    `);

    const archival_collections = data.collections.edges;

    // Filter to the category
    let category_collections = archival_collections.filter((element) => {
        return element.node.field_aci_archives_category === category;
    })

    // Filter to the other category
    let other_category_collections = null;
    if (other_category !== null) {
        other_category_collections = archival_collections.filter((element) => {
            return element.node.field_aci_other_category.includes(other_category);
        })
    }

    // Create a single sorted array of all the collections by uninoing the category and the subcategory. 
    let filtered_collections = array_union(category_collections, other_category_collections);
    sort_node_title(filtered_collections);

    // Format rows
    let collection_rows = filtered_collections.map((element) => {
        return (
            <tr className="table-row">
                <td><Link to={element.node.path.alias}>{element.node.title}</Link></td>
                <td dangerouslySetInnerHTML={{__html: element.node.field_aci_short_description}}></td>
                <td>{element.node.field_aci_dates}</td>
            </tr>
        )
    })

    return (<>
        <table className="archival_collection">
            <caption>A list of Archival &amp; Special Collections Resources</caption>
            <tr className="header">
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Dates</th>
            </tr>
            {collection_rows}
        </table>
    </>);
       
}

ArchivalCollection.propTypes = {
	category: PropTypes.string,
    other_category: PropTypes.string
}

ArchivalCollection.defaultProps = {
    other_category: null
}
export default ArchivalCollection